module.exports = require("rxjs/operators/filter");


//////////////////
// WEBPACK FOOTER
// external "rxjs/operators/filter"
// module id = 55
// module chunks = 0